import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import classNames from 'classnames';
import { AlignContainer, BaseSpinner } from 'wbs-components-lib';

import { Box, Typography } from '@mui/material';

import { useGetVipTaskItemsByTaskIdQuery } from '@services';

import { AppDispatch, getVipTaskItemsByTaskIdSelector, setVipTaskItems } from '@store';

import { VipTaskItemsProps } from './types';
import { VipTaskItem } from './VipTaskItem';

import styles from './VipTaskItems.module.css';

const { vipTaskItemsContainer, vipTaskItemsEmptyContainer } = styles;

export const VipTaskItems: FC<VipTaskItemsProps> = ({
  vipTask,
  isItemsExpanded,
  handleVipTaskItemEditModalOpen,
  handleVipTaskItemDeleteModalOpen,
  handleVipTaskItemExport,
  handleVipTaskItemValidateModalOpen,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const currentVipTaskItems = useSelector(getVipTaskItemsByTaskIdSelector(vipTask.id));

  const isVipTaskItemsEmpty = currentVipTaskItems.length === 0;

  const { data: vipTaskItems, isLoading: isItemsLoading } = useGetVipTaskItemsByTaskIdQuery(vipTask.id, {
    refetchOnMountOrArgChange: true,
    skip: !isVipTaskItemsEmpty || !isItemsExpanded,
  });

  useEffect(() => {
    if (vipTaskItems !== undefined) {
      dispatch(
        setVipTaskItems({
          vipTaskItems,
          vipTaskId: vipTask.id,
        })
      );
    }
  }, [vipTaskItems]);

  return (
    <Box
      className={classNames(vipTaskItemsContainer, {
        [vipTaskItemsEmptyContainer]: isVipTaskItemsEmpty,
      })}
    >
      {!isItemsLoading ? (
        <>
          {!isVipTaskItemsEmpty ? (
            <>
              {currentVipTaskItems.map((vipTaskItem) => (
                <VipTaskItem
                  key={vipTaskItem.id}
                  vipTask={vipTask}
                  vipTaskItem={vipTaskItem}
                  handleVipTaskItemEditModalOpen={handleVipTaskItemEditModalOpen}
                  handleVipTaskItemDeleteModalOpen={handleVipTaskItemDeleteModalOpen}
                  handleVipTaskItemExport={handleVipTaskItemExport}
                  handleVipTaskItemValidateModalOpen={handleVipTaskItemValidateModalOpen}
                />
              ))}
            </>
          ) : (
            <Typography align="center">No task items</Typography>
          )}
        </>
      ) : (
        <AlignContainer>
          <BaseSpinner />
        </AlignContainer>
      )}
    </Box>
  );
};
